<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      accessKeyId: '',
      accessKeySecret: '',
      custSpaceId: '',
      phoneNumber: '',
      region: 'ap-southeast-1',
      regionOptions: [
        { value: 'ap-southeast-1', label: 'ap-southeast-1' },
        { value: 'ap-northeast-1', label: 'ap-northeast-1' },
        { value: 'us-west-1', label: 'us-west-1' },
        { value: 'eu-central-1', label: 'eu-central-1' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations() {
    return {
      channelName: { required },
      accessKeyId: { required },
      accessKeySecret: { required },
      custSpaceId: { required },
      phoneNumber: { required },
      region: { required },
    };
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const chatappChannel = await this.$store.dispatch(
          'inboxes/createChatappChannel',
          {
            chatapp_channel: {
              name: this.channelName?.trim(),
              access_key_id: this.accessKeyId?.trim(),
              access_key_secret: this.accessKeySecret?.trim(),
              cust_space_id: this.custSpaceId?.trim(),
              phone_number: this.phoneNumber?.trim(),
              region: this.region,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: chatappChannel.id,
          },
        });
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          this.$t('INBOX_MGMT.ADD.CHATAPP.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.channelName.$error }">
        {{ $t('INBOX_MGMT.ADD.CHATAPP.CHANNEL_NAME.LABEL') }}
        <input
          v-model="channelName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.CHATAPP.CHANNEL_NAME.PLACEHOLDER')"
          @blur="v$.channelName.$touch"
        />
        <span v-if="v$.channelName.$error" class="message">{{
          $t('INBOX_MGMT.ADD.CHATAPP.CHANNEL_NAME.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.accessKeyId.$error }">
        {{ $t('INBOX_MGMT.ADD.CHATAPP.ACCESS_KEY_ID.LABEL') }}
        <input
          v-model="accessKeyId"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.CHATAPP.ACCESS_KEY_ID.PLACEHOLDER')"
          @blur="v$.accessKeyId.$touch"
        />
        <span v-if="v$.accessKeyId.$error" class="message">{{
          $t('INBOX_MGMT.ADD.CHATAPP.ACCESS_KEY_ID.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.accessKeySecret.$error }">
        {{ $t('INBOX_MGMT.ADD.CHATAPP.ACCESS_KEY_SECRET.LABEL') }}
        <input
          v-model="accessKeySecret"
          type="password"
          :placeholder="
            $t('INBOX_MGMT.ADD.CHATAPP.ACCESS_KEY_SECRET.PLACEHOLDER')
          "
          @blur="v$.accessKeySecret.$touch"
        />
        <span v-if="v$.accessKeySecret.$error" class="message">{{
          $t('INBOX_MGMT.ADD.CHATAPP.ACCESS_KEY_SECRET.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.custSpaceId.$error }">
        {{ $t('INBOX_MGMT.ADD.CHATAPP.CUST_SPACE_ID.LABEL') }}
        <input
          v-model="custSpaceId"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.CHATAPP.CUST_SPACE_ID.PLACEHOLDER')"
          @blur="v$.custSpaceId.$touch"
        />
        <span v-if="v$.custSpaceId.$error" class="message">{{
          $t('INBOX_MGMT.ADD.CHATAPP.CUST_SPACE_ID.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.CHATAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.CHATAPP.PHONE_NUMBER.PLACEHOLDER')"
          @blur="v$.phoneNumber.$touch"
        />
        <span v-if="v$.phoneNumber.$error" class="message">{{
          $t('INBOX_MGMT.ADD.CHATAPP.PHONE_NUMBER.ERROR')
        }}</span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.region.$error }">
        {{ $t('INBOX_MGMT.ADD.CHATAPP.REGION.LABEL') }}
        <select v-model="region">
          <option
            v-for="opt in regionOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>
        <span v-if="v$.region.$error" class="message">{{
          $t('INBOX_MGMT.ADD.CHATAPP.REGION.ERROR')
        }}</span>
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.CHATAPP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
